import * as ga from "../../lib/ga";

export const insuranceSearchSubmitTracker = (searchTerm: string, searchResults: number) => {
  const trackingData = {
    event: "view_search_results",
    event_parameters: {
      page_location: window.location.href,
      search_term: searchTerm?.toLowerCase(),
      search_results: searchResults,
    },
  };
  ga.gaTracking(trackingData);
};

export const insuranceSearchResultClickTracker = (
  searchTerm: string,
  searchResults: number,
  resultTitle: string
) => {
  const trackingData = {
    event: "select_search_results",
    event_parameters: {
      page_location: window.location.href.split("?")[0],
      search_term: searchTerm?.toLowerCase(),
      search_results: searchResults,
      selected_search_result: resultTitle?.toLowerCase(),
    },
  };
  ga.gaTracking(trackingData);
};
